<template>
  <transition-group
    name="notify"
    class="c-notifications"
    tag="ul"
  >
    <li
      class="notification"
      data-cy="notification"
      :class="'-' + notification.type"
      v-for="(notification, index) in notifications"
      :key="`notification-${index}`"
    >
      <c-icon
        class="icon"
        :icon="getIcon(notification)"
      />
      <p
        class="message"
        v-html="notification.message"
      />
      <c-button
        class="button"
        icon="cross"
        @click="close(notification)"
      />
    </li>
  </transition-group>
</template>

<script>
export default {
  props: {
    notifications: {
      type: Array,
      default: () => []
    },
    zIndex: {
      type: Number,
      default: 1101
    }
  },
  mounted () {
    this.$el.style.zIndex = this.zIndex
  },
  methods: {
    close (notification) {
      this.$emit('close', notification)
    },
    getIcon (notification) {
      const icons = {
        info: 'info-circle',
        error: 'thumbs-down',
        success: 'thumbs-up'
      }
      const icon = icons[notification.type] || icons.info
      return icon
    }
  }
}
</script>

<style lang="scss">
@import '~@styles/convenia-components/reference.scss';

$c-notification-min-height: 54px;
$c-notification-spacing: 12px;
$c-notification-colors: (
  info: #b4b4b4,
  error: #ef5959,
  success: #59efb2
) !default;

.notify-enter-active,
.notify-leave-active {
  transition: all 0.3s;
}
.notify-enter,
.notify-leave-to {
  opacity: 0;
  transform: translate(0, 100%);

  @include small-up {
    transform: translate(-100%, 0);
  }
}

.c-notifications {
  position: fixed;
  left: 0;
  width: 100%;
  padding: 0;
  margin: 0;
  bottom: 0;

  @include small-up {
    width: 398px;
  }

  & > .notification {
    @include elevation(2);
    box-sizing: border-box;
    display: flex;
    align-items: center;
    width: 100%;
    min-height: $c-notification-min-height;
    padding: $c-notification-spacing;
    border-radius: 0 3px 3px 0;

    @include small-up {
      margin-bottom: $c-notification-spacing;
    }

    & > .message {
      color: #fff;
      margin: 0 12px;
    }

    & > .icon {
      width: 34px;
      min-width: 34px;
      height: 34px;
      padding: 5px;
      border-radius: 50%;
      background-color: #fff;
    }

    & > .button {
      margin-left: auto;
      border: 1px solid rgba(#000, .15);
    }

    & > .button > .icon { fill: #fff !important; }

    @each $type, $color in $c-notification-colors {
      &.-#{$type} {
        background-color: $color;

        & > .icon { fill: $color !important; }
        & > .button { background-color: $color; }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CNotifications.vue